import React, { useEffect, useState, useContext, useRef, useMemo } from 'react';
import HeaderSection from "../banner/HeaderSection";
import { Modal } from 'react-bootstrap';
import JoditEditor from 'jodit-react';
import { toast } from "react-toastify";
import axios from 'axios';
import * as CONST from "../../../component/config/Constant";
import { AuthContext } from '../../../component/context/AuthContext';
import Select from 'react-select';
import MultiSelect from 'react-multiple-select-dropdown-lite';
import 'react-multiple-select-dropdown-lite/dist/index.css';
import Loading from "react-fullscreen-loading";
import { Link } from "react-router-dom";
import "../../../assets/css/helpdesk.css";
import "../../../assets/css/dashboard.css";
import moment from 'moment';
import Parser from 'html-react-parser';
import DivSpinner from "../../../component/utilities/Spinner";
import { FiSend, FiSearch, FiAlertCircle, FiClock, FiCheckCircle, FiXCircle, FiMinusCircle } from "react-icons/fi";
import { StatusBadge, PriorityBadge, PriorityPills } from "../../../component/utilities/Badges";

function ApplyTickets() {
  const [authUserData] = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const [validate, setValidate] = useState({});
  const [to, setTo] = useState('');
  const [cc, setCc] = useState('');
  const [subject, setSubject] = useState('');
  const editor = useRef(null);
  const [reason, setReason] = useState('');
  const [priority, setPriority] = useState('medium');
  const [headUsers, setHeadUsers] = useState('');
  const [newHeadsCC, setNewHeadsCC] = useState([]);
  const [multidept, setmultideptlist] = useState([]);
  const [fullLoading, setFullLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);

  // Ticket list
  const [tickets, setTickets] = useState([]);
  const [allTickets, setAllTickets] = useState([]);
  const [activeTicket, setActiveTicket] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  // Comments
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [empAssetHistory, setEmpAssetHistory] = useState([]);
  const [centerTab, setCenterTab] = useState('conversation');
  const [pendingHandovers, setPendingHandovers] = useState([]);
  const [acknowledging, setAcknowledging] = useState(false);

  // Category
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('general');
  const [assetTypes, setAssetTypes] = useState([]);
  const [selectedAssetType, setSelectedAssetType] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [justification, setJustification] = useState('');

  // Validation errors
  const [toError, settoError] = useState('');
  const [ccError, setccError] = useState('');
  const [reasonError, setreasonError] = useState('');
  const [subjectError, setsubjectError] = useState('');

  let user_id = '';
  let isToken = '';
  let is_admin = 0;
  let is_head = 0;
  let department_id = '';
  if (authUserData && authUserData[0]) {
    isToken = authUserData[0].token || "";
    user_id = authUserData[0].user_id || "";
    is_admin = authUserData[0].is_admin || 0;
    is_head = authUserData[0].is_head || 0;
    department_id = authUserData[0].department_id || "";
  }
  const canSelectDept = is_admin == "1" || is_head == "1";

  const config = useMemo(() => ({
    readonly: false,
    uploader: { "insertImageAsBase64URI": true }
  }), []);

  useEffect(() => {
    fetchHeadUser();
    fetchHeadCCMails('');
    getDepartmentList();
    getTicketList();
    fetchCategories();
    fetchAssetTypes();
    fetchPendingHandovers();
  }, []);

  async function fetchPendingHandovers() {
    try {
      const res = await axios.post(CONST.PENDING_HANDOVERS, { user_id }, { headers: { Authorization: `Bearer ${isToken}` } });
      if (res.data.status === 'success') setPendingHandovers(res.data.data || []);
    } catch (e) {}
  }

  const handleAcknowledge = async (handoverId) => {
    setAcknowledging(true);
    try {
      const res = await axios.post(CONST.ACKNOWLEDGE_HANDOVER + handoverId, {}, { headers: { Authorization: `Bearer ${isToken}` } });
      if (res.data.status === 'success') {
        toast.success("Asset receipt acknowledged.");
        fetchPendingHandovers();
      } else toast.error(res.data.message);
    } catch (e) { toast.error("Something went wrong."); }
    setAcknowledging(false);
  };

  // ===== DATA FETCHING =====
  async function getTicketList() {
    setLoading(true);
    try {
      const response = await axios.post(CONST.GET_TICKET_LIST, {
        user_id, sort: { order_by: "id", order: "desc" },
        page_number: 1, limit: 10000, is_head: 0, srchDate: '', username: '',
        departmentName: '', ticketId: '', owner_only: 1
      }, { headers: { Authorization: `Basic ${isToken}` } });

      if (response.data.status === "success") {
        // My Tickets: only show tickets created BY the logged-in user
        let filtered = (response.data.data || []).filter(t =>
          t.createdByData && t.createdByData.id == user_id
        );
        setAllTickets(filtered);
        setTickets(filtered);
      } else {
        setAllTickets([]);
        setTickets([]);
      }
    } catch (e) {}
    setLoading(false);
  }

  const fetchHeadUser = async () => {
    try {
      const response = await axios.get(CONST.SUPPORT_USER_LIST, {
        headers: { Authorization: `Basic ${isToken}` }
      });
      if (response.data.status === 'success') {
        setHeadUsers(response.data.data.map(e => ({ value: e.id, label: e.name })));
      }
    } catch (e) {}
  };

  async function fetchHeadCCMails(val) {
    try {
      const response = await axios.post(CONST.GET_HEAD_CC_EMAILS, {
        id: user_id, department_id: val
      }, { headers: { Authorization: `Bearer ${isToken}` } });
      if (response.data.status === 'success') {
        const sorted = response.data.data.map(v => ({ label: v.name, value: v.id.toString() }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setNewHeadsCC(sorted);
      }
    } catch (e) {}
  }

  async function getDepartmentList() {
    try {
      const response = await axios.post(CONST.GET_ACTIVE_DEPARTMENT_LIST, {
        headers: { Authorization: `Basic ${isToken}` }
      });
      if (response.data.status === "success") {
        setmultideptlist(response.data.data.map(v => ({ label: v.name, value: v.id.toString() })));
      }
    } catch (e) {}
  }

  async function fetchCategories() {
    try {
      const res = await axios.get(CONST.REQUEST_CATEGORY_LIST_ACTIVE, {
        headers: { Authorization: `Bearer ${isToken}` }
      });
      if (res.data.status === 'success') setCategories(res.data.data || []);
    } catch (e) {}
  }

  async function fetchAssetTypes() {
    try {
      const res = await axios.get(CONST.ASSETS_TYPE_LIST, {
        headers: { Authorization: `Bearer ${isToken}` }
      });
      if (res.data.status === 'success') setAssetTypes(res.data.data || []);
    } catch (e) {}
  }

  const fetchComments = async (ticketId) => {
    setCommentsLoading(true);
    try {
      const response = await axios.post(CONST.GET_COMMENT, {
        fk_ticket_id: ticketId
      }, { headers: { Authorization: `Bearer ${isToken}` } });
      if (response.data.status === 'success') {
        setComments(response.data.data || []);
      } else {
        setComments([]);
      }
    } catch (e) {}
    setCommentsLoading(false);
  };

  // ===== ACTIONS =====
  const handleTicketClick = (ticket) => {
    setActiveTicket(ticket);
    fetchComments(ticket.id);
    setCenterTab('conversation');
    setEmpAssetHistory([]);
    if (ticket.category === 'hardware_request') {
      fetchEmpAssetHistory(user_id);
    }
  };

  const fetchEmpAssetHistory = async (empId) => {
    try {
      const res = await axios.post(CONST.MY_ASSET_ITEMS, { user_id: empId }, { headers: { Authorization: `Bearer ${isToken}` } });
      const data = res.data.status === 'success' ? (res.data.data || []).map(a => ({
        name: a.assetType?.name || '-', brand: a.brand?.name || '-',
        status: 'Allocated', statusColor: '#059669',
        date: a.updated_at, tag: a.asset_tag
      })) : [];
      setEmpAssetHistory(data);
    } catch (e) {}
  };

  const handleSendComment = async () => {
    if (!newComment.trim() || !activeTicket) return;
    try {
      await axios.post(CONST.ADD_COMMENT, {
        fk_ticket_id: activeTicket.id,
        comment_added_by: user_id,
        comment: newComment
      }, { headers: { Authorization: `Basic ${isToken}`, 'Content-Type': 'application/json' } });
      setNewComment('');
      fetchComments(activeTicket.id);
    } catch (e) {
      toast.error("Failed to send comment.");
    }
  };

  const handleReopenTicket = async () => {
    if (!activeTicket) return;
    try {
      await axios.post(CONST.UPDATE_STATUS_TICKET, {
        ticket_id: activeTicket.id, status: "0"
      }, { headers: { Authorization: `Basic ${isToken}` } });
      toast.success("Request reopened.");
      setActiveTicket({ ...activeTicket, status: "0" });
      getTicketList();
    } catch (e) {
      toast.error("Failed to reopen request.");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendComment();
    }
  };

  const handleSearch = (val) => {
    setSearchQuery(val);
    if (!val) { setTickets(allTickets); return; }
    const q = val.toLowerCase();
    setTickets(allTickets.filter(t =>
      (t.title && t.title.toLowerCase().includes(q)) ||
      (t.createdByData && (t.createdByData.first_name + ' ' + t.createdByData.last_name).toLowerCase().includes(q)) ||
      (t.id && t.id.toString().includes(q))
    ));
  };

  const valdations = async () => {
    let valid = true;
    settoError(''); setccError(''); setsubjectError(''); setreasonError('');
    if (!to) { settoError('Assign to is required'); valid = false; }
    if (!cc) { setccError('CC is required'); valid = false; }
    if (!subject) { setsubjectError('Subject is required'); valid = false; }
    if (!reason) { setreasonError('Reason is required'); valid = false; }
    return valid;
  };

  const handleSubmit = async () => {
    if (!(await valdations())) return;
    if (selectedCategory === 'hardware_request' && !selectedAssetType) {
      toast.error("Please select an asset type.");
      return;
    }
    setDisabled(true);
    try {
      const payload = {
        cc_user_id: cc, title: subject, description: reason,
        createdby: user_id, createdfor: to, status: 0, priority,
        category: selectedCategory,
        asset_type_id: selectedCategory === 'hardware_request' ? selectedAssetType : null,
        quantity: selectedCategory === 'hardware_request' ? quantity : 1,
        justification: selectedCategory === 'hardware_request' ? justification : null,
      };
      const res = await axios.post(CONST.CREATE_SUPPORT_TICKET, payload, {
        headers: { Authorization: `Basic ${isToken}`, 'Content-Type': 'application/json' }
      });
      if (res.data.status === 'error') {
        toast.error(res.data.message || "Something went wrong.");
      } else {
        toast.success("Request created successfully.");
        setShow(false); setTo(''); setCc(''); setSubject(''); setReason(''); setPriority('medium');
        setSelectedCategory('general'); setSelectedAssetType(''); setQuantity(1); setJustification('');
        getTicketList();
      }
    } catch (e) {
      console.log("Create request error:", e);
      toast.error("Something went wrong.");
    }
    setDisabled(false);
  };

  // ===== HELPERS =====
  const getStatusStyle = (status) => {
    const map = {
      "0": { bg: "#dbeafe", color: "#1e40af", label: "Open" },
      "7": { bg: "#e0e7ff", color: "#3730a3", label: "Accepted" },
      "8": { bg: "#fffbeb", color: "#d97706", label: "Pending Approval" },
      "5": { bg: "#f3e8ff", color: "#7c3aed", label: "Approved" },
      "1": { bg: "#fff3cd", color: "#856404", label: "In Progress" },
      "2": { bg: "#d1fae5", color: "#065f46", label: "Allocated" },
      "9": { bg: "#d4edda", color: "#155724", label: "Resolved" },
      "3": { bg: "#fee2e2", color: "#dc2626", label: "Rejected" },
      "4": { bg: "#e2e8f0", color: "#475569", label: "Closed" },
      "6": { bg: "#f1f5f9", color: "#64748b", label: "Returned" },
    };
    return map[status] || { bg: "#f1f5f9", color: "#64748b", label: "Unknown" };
  };

  const getPriorityStyle = (p) => {
    if (p === 'high') return { bg: "#fee2e2", color: "#dc2626" };
    if (p === 'medium') return { bg: "#fef3c7", color: "#b45309" };
    return { bg: "#ecfdf5", color: "#059669" };
  };

  const timeAgo = (date) => {
    const m = moment(date);
    const diff = moment().diff(m, 'hours');
    if (diff < 1) return moment().diff(m, 'minutes') + 'm ago';
    if (diff < 24) return diff + 'h ago';
    if (diff < 48) return 'Yesterday';
    return m.format('DD-MM-YYYY');
  };

  const statCards = [
    { status: "0", label: "Open", icon: <FiAlertCircle size={18} />, bg: "#dbeafe", color: "#1e40af" },
    { status: "7", label: "Accepted", icon: <FiCheckCircle size={18} />, bg: "#e0e7ff", color: "#3730a3" },
    { status: "8", label: "Pending Approval", icon: <FiClock size={18} />, bg: "#fffbeb", color: "#d97706" },
    { status: "5", label: "Approved", icon: <FiCheckCircle size={18} />, bg: "#f3e8ff", color: "#7c3aed" },
    { status: "1", label: "In Progress", icon: <FiClock size={18} />, bg: "#fef3c7", color: "#b45309" },
    { status: "2", label: "Allocated", icon: <FiCheckCircle size={18} />, bg: "#d1fae5", color: "#065f46" },
    { status: "9", label: "Resolved", icon: <FiCheckCircle size={18} />, bg: "#d4edda", color: "#155724" },
    { status: "3", label: "Rejected", icon: <FiXCircle size={18} />, bg: "#fee2e2", color: "#dc2626" },
    { status: "4", label: "Closed", icon: <FiMinusCircle size={18} />, bg: "#f1f5f9", color: "#475569" },
  ];

  return (
    <>
      <Loading loading={fullLoading} background="rgba(0,0,0,0.5)" loaderColor="#fff" />
      <HeaderSection title="My" heading="Requests" addButton={() => setShow(true)} addLink="#" addLinkName="Create Request" linktype="add" />

      {/* Pending Handover Banner */}
      {pendingHandovers.length > 0 && (
        <div className="container-xl mt-3">
          <div style={{ background: '#fffbeb', border: '1px solid #fbbf24', borderRadius: 8, padding: '12px 16px' }}>
            <strong style={{ color: '#92400e' }}>Pending Asset Acknowledgment</strong>
            <p style={{ fontSize: '0.82rem', color: '#78350f', margin: '6px 0 0' }}>You have {pendingHandovers.length} asset(s) to acknowledge receipt:</p>
            {pendingHandovers.map((h, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#fff', borderRadius: 6, padding: '8px 12px', marginTop: 8, border: '1px solid #fde68a' }}>
                <div>
                  <span style={{ fontWeight: 700, color: '#1167e8', marginRight: 8 }}>{h.assetItem?.asset_tag}</span>
                  <span style={{ fontSize: '0.82rem' }}>{h.assetItem?.assetType?.name || ''} - {h.assetItem?.brand?.name || ''}</span>
                  <span style={{ fontSize: '0.75rem', color: '#64748b', marginLeft: 8 }}>Issued by {h.issuedByUser?.first_name} {h.issuedByUser?.last_name}</span>
                </div>
                <button className="btn btn-success btn-sm" onClick={() => handleAcknowledge(h.id)} disabled={acknowledging} style={{ fontSize: '0.78rem' }}>
                  {acknowledging ? 'Processing...' : 'Acknowledge Receipt'}
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Stats Cards */}
      <div className="container-xl mt-3">
        <div className="row db-stats-row">
          {statCards.map((s) => (
            <div className="col-6 col-md-2 mb-2" key={s.status}>
              <div className="db-stat-card" style={{ cursor: "pointer" }}
                onClick={() => handleSearch(s.label)}>
                <div className="db-stat-icon" style={{ background: s.bg, color: s.color }}>{s.icon}</div>
                <div className="db-stat-value">{allTickets.filter(t => t.status === s.status).length}</div>
                <div className="db-stat-label">{s.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 3-Panel Layout */}
      <div className="container-xl mt-3 mb-4">
        <div className="helpdesk-wrapper">

          {/* LEFT — Ticket List */}
          <div className="helpdesk-list">
            <div className="helpdesk-list-header">
              <h6>Requests ({allTickets.length})</h6>
              <div className="helpdesk-list-search">
                <FiSearch />
                <input
                  type="text"
                  placeholder="Search requests..."
                  value={searchQuery}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </div>
            </div>
            <div className="helpdesk-list-body">
              {loading ? <div className="p-3"><DivSpinner size="sm" color="primary" /></div> :
                tickets.length === 0 ? <div className="p-3 text-center text-muted" style={{ fontSize: "0.82rem" }}>No requests found</div> :
                tickets.map((t) => {
                  const ss = getStatusStyle(t.status);
                  const ps = getPriorityStyle(t.priority);
                  return (
                    <div
                      key={t.id}
                      className={`helpdesk-ticket-item ${activeTicket && activeTicket.id === t.id ? 'active' : ''}`}
                      onClick={() => handleTicketClick(t)}
                    >
                      <div className="ticket-top">
                        <span className="ticket-id">#REQ-{String(t.id).padStart(3, '0')}</span>
                        <span className="ticket-time">{timeAgo(t.created_at)}</span>
                      </div>
                      <div className="ticket-name">
                        {t.createdByData ? t.createdByData.first_name + ' ' + t.createdByData.last_name : 'Unknown'}
                      </div>
                      <div className="ticket-subject">{t.title}</div>
                      <div className="ticket-meta">
                        <StatusBadge status={ss.label} />
                        {t.priority && <PriorityBadge priority={t.priority} />}
                      </div>
                    </div>
                  );
                })
              }
            </div>
          </div>

          {/* CENTER — Conversation */}
          <div className="helpdesk-chat">
            {activeTicket ? (
              <>
                <div className="helpdesk-chat-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <span className="chat-ticket-id">#REQ-{String(activeTicket.id).padStart(3, '0')}</span>
                    <span className="chat-ticket-title">{activeTicket.title}</span>
                  </div>
                  {activeTicket.category === 'hardware_request' && (
                  <div style={{ display: 'flex', gap: '4px' }}>
                    <button
                      style={{ padding: '4px 12px', fontSize: '0.75rem', fontWeight: 600, borderRadius: 6, border: centerTab === 'conversation' ? '2px solid #1167e8' : '1px solid #e2e8f0', background: centerTab === 'conversation' ? '#f0f5ff' : '#fff', color: centerTab === 'conversation' ? '#1167e8' : '#64748b', cursor: 'pointer' }}
                      onClick={() => setCenterTab('conversation')}
                    >Conversation</button>
                    <button
                      style={{ padding: '4px 12px', fontSize: '0.75rem', fontWeight: 600, borderRadius: 6, border: centerTab === 'history' ? '2px solid #1167e8' : '1px solid #e2e8f0', background: centerTab === 'history' ? '#f0f5ff' : '#fff', color: centerTab === 'history' ? '#1167e8' : '#64748b', cursor: 'pointer' }}
                      onClick={() => setCenterTab('history')}
                    >History ({empAssetHistory.length})</button>
                  </div>
                  )}
                </div>

                {centerTab === 'history' ? (
                <div className="helpdesk-chat-body" style={{ padding: '16px' }}>
                  <h6 style={{ fontSize: '0.85rem', fontWeight: 700, marginBottom: 12 }}>My Asset History</h6>
                  {empAssetHistory.length === 0 ? (
                    <p style={{ color: '#94a3b8', fontSize: '0.82rem' }}>No previous asset requests found.</p>
                  ) : (
                    <table className="table table-sm table-bordered" style={{ fontSize: '0.8rem' }}>
                      <thead style={{ background: '#f0f5ff' }}>
                        <tr><th>#</th><th>Asset Tag</th><th>Asset Type</th><th>Brand</th><th>Status</th><th>Date</th></tr>
                      </thead>
                      <tbody>
                        {empAssetHistory.map((a, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td style={{ fontWeight: a.tag !== '-' ? 700 : 400, color: a.tag !== '-' ? '#1167e8' : '#94a3b8' }}>{a.tag}</td>
                            <td>{a.name}</td>
                            <td>{a.brand}</td>
                            <td><span style={{ color: a.statusColor, fontWeight: 600, fontSize: '0.72rem' }}>{a.status}</span></td>
                            <td>{a.date ? moment(a.date).format('DD MMM YYYY') : '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
                ) : (
                <div className="helpdesk-chat-body">
                  {/* Ticket description as first message */}
                  {(() => {
                    const iAmCreator = String(activeTicket.createdByData?.id) === String(user_id);
                    return (
                      <div className={`chat-message ${iAmCreator ? 'own' : 'other'}`}>
                        <div className="chat-bubble">
                          {activeTicket.description ? Parser(activeTicket.description) : ''}
                        </div>
                        <div className="chat-meta">
                          <span className="chat-author">
                            {iAmCreator ? 'You' : (activeTicket.createdByData ? activeTicket.createdByData.first_name + ' ' + activeTicket.createdByData.last_name : '')}
                          </span> · {moment(activeTicket.created_at).format('DD-MM-YYYY, h:mm a')}
                        </div>
                      </div>
                    );
                  })()}

                  {/* Comments */}
                  {commentsLoading ? <div className="text-center py-3"><DivSpinner size="sm" color="primary" /></div> :
                    comments.length > 0 && comments.map((c) => {
                      const isMe = String(c.comment_added_by) === String(user_id);
                      const isSystem = c.comment && (c.comment.includes('changed the status to') || c.comment.includes('approved this request') || c.comment.includes('rejected this request') || c.comment.includes('allocated asset'));
                      if (isSystem) {
                        return <div className="chat-system" key={c.id}><span>{c.comment}</span></div>;
                      }
                      return (
                        <div key={c.id} className={`chat-message ${isMe ? 'own' : 'other'}`}>
                          <div className="chat-bubble">{c.comment}</div>
                          <div className="chat-meta">
                            <span className="chat-author">{isMe ? 'You' : (c.user ? c.user.first_name + ' ' + c.user.last_name : 'Unknown')}</span>
                            {' · '}{moment(c.created_at).format('DD-MM-YYYY, h:mm a')}
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
                )}

                {/* Input — disabled if closed/resolved, show reopen option */}
                {activeTicket.status === "4" || activeTicket.status === "2" ? (
                  <div className="helpdesk-chat-input" style={{ justifyContent: "center" }}>
                    <span style={{ fontSize: "0.78rem", color: "#94a3b8" }}>
                      This request is {activeTicket.status === "4" ? "closed" : "resolved"}.
                    </span>
                    <button
                      className="btn btn-sm"
                      style={{ fontSize: "0.75rem", padding: "4px 14px", borderRadius: "20px", border: "1.5px solid #1167e8", color: "#1167e8", background: "#f0f5ff", marginLeft: "10px" }}
                      onClick={handleReopenTicket}
                    >
                      Reopen Request
                    </button>
                  </div>
                ) : (
                  <div className="helpdesk-chat-input">
                    <textarea
                      rows="1"
                      placeholder="Type your message..."
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                      onKeyPress={handleKeyPress}
                    />
                    <button className="send-btn" onClick={handleSendComment} disabled={!newComment.trim()}>
                      <FiSend size={16} />
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div className="helpdesk-chat-empty">Select a request to view conversation</div>
            )}
          </div>

          {/* RIGHT — Request Details */}
          <div className="helpdesk-details">
            {activeTicket ? (
              <>
                <div className="helpdesk-details-header">
                  <h6>Request Details</h6>
                </div>
                <div className="helpdesk-details-body">
                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Assignee</div>
                    <div className="helpdesk-detail-value">
                      <div className="assignee-row">
                        <div className="assignee-avatar">
                          {activeTicket.createdForData ? activeTicket.createdForData.first_name?.charAt(0) + activeTicket.createdForData.last_name?.charAt(0) : '?'}
                        </div>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: "0.82rem" }}>
                            {activeTicket.createdForData ? activeTicket.createdForData.first_name + ' ' + activeTicket.createdForData.last_name : '-'}
                          </div>
                          <div style={{ fontSize: "0.72rem", color: "#64748b" }}>
                            {activeTicket.createdForData?.email || ''}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {activeTicket.category && activeTicket.category !== 'general' && (
                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Category</div>
                    <div className="helpdesk-detail-value">
                      <span style={{ background: activeTicket.category === 'hardware_request' ? '#dbeafe' : activeTicket.category === 'software_request' ? '#f3e8ff' : activeTicket.category === 'it_support' ? '#ffedd5' : '#dcfce7', color: activeTicket.category === 'hardware_request' ? '#1e40af' : activeTicket.category === 'software_request' ? '#7c3aed' : activeTicket.category === 'it_support' ? '#c2410c' : '#166534', padding: '2px 10px', borderRadius: 12, fontSize: '0.72rem', fontWeight: 600 }}>
                        {activeTicket.category === 'hardware_request' ? 'Hardware Request' : activeTicket.category === 'software_request' ? 'Software Request' : activeTicket.category === 'it_support' ? 'IT Support' : 'Access Request'}
                      </span>
                    </div>
                  </div>
                  )}

                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Status</div>
                    <div className="helpdesk-detail-value">
                      <StatusBadge status={getStatusStyle(activeTicket.status).label} />
                    </div>
                  </div>

                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Priority</div>
                    <PriorityBadge priority={activeTicket.priority} />
                  </div>

                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Subject</div>
                    <div className="helpdesk-detail-value">{activeTicket.title}</div>
                  </div>

                  {activeTicket.category === 'hardware_request' && activeTicket.assetType && (
                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Asset Type</div>
                    <div className="helpdesk-detail-value">{activeTicket.assetType?.name || '-'}</div>
                  </div>
                  )}

                  {activeTicket.category === 'hardware_request' && activeTicket.quantity && (
                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Quantity</div>
                    <div className="helpdesk-detail-value">{activeTicket.quantity}</div>
                  </div>
                  )}

                  {activeTicket.category === 'hardware_request' && activeTicket.justification && (
                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Justification</div>
                    <div className="helpdesk-detail-value">{activeTicket.justification}</div>
                  </div>
                  )}

                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Created By</div>
                    <div className="helpdesk-detail-value">
                      {activeTicket.createdByData ? activeTicket.createdByData.first_name + ' ' + activeTicket.createdByData.last_name : '-'}
                    </div>
                  </div>

                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Date</div>
                    <div className="helpdesk-detail-value">{moment(activeTicket.created_at).format('DD MMM YYYY, h:mm a')}</div>
                  </div>

                  {activeTicket.e_support_cc_mails && activeTicket.e_support_cc_mails.length > 0 && (
                    <div className="helpdesk-detail-group">
                      <div className="helpdesk-detail-label">CC</div>
                      <ul className="helpdesk-cc-list">
                        {activeTicket.e_support_cc_mails.map((cc, i) => (
                          <li key={i}>{cc.user ? cc.user.first_name + ' ' + cc.user.last_name : cc.cc_user_id}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className="helpdesk-details-header">
                <h6>Request Details</h6>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Create Request Modal */}
      <Modal size="lg" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton style={{ borderBottom: 'none' }}>
          <Modal.Title>Create Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {/* Category */}
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label required">Category</label>
                <Select
                  placeholder="Select Category"
                  options={categories.map(c => ({ value: c.code, label: c.name }))}
                  value={selectedCategory ? categories.filter(c => c.code === selectedCategory).map(c => ({ value: c.code, label: c.name }))[0] : null}
                  onChange={opt => setSelectedCategory(opt ? opt.value : 'general')}
                />
              </div>
            </div>
            {/* Priority */}
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label required">Priority</label>
                <Select
                  placeholder="Select Priority"
                  options={[{ value: 'low', label: 'Low' }, { value: 'medium', label: 'Medium' }, { value: 'high', label: 'High' }, { value: 'urgent', label: 'Urgent' }]}
                  value={{ value: priority, label: priority.charAt(0).toUpperCase() + priority.slice(1) }}
                  onChange={opt => setPriority(opt ? opt.value : 'medium')}
                />
              </div>
            </div>
            {/* Hardware Request: Asset Type + Quantity */}
            {selectedCategory === 'hardware_request' && (
              <>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label className="form-label required">Asset Type</label>
                    <Select
                      placeholder="Select Asset Type"
                      options={assetTypes.map(a => ({ value: a.id, label: a.name }))}
                      value={selectedAssetType ? assetTypes.filter(a => a.id == selectedAssetType).map(a => ({ value: a.id, label: a.name }))[0] : null}
                      onChange={opt => setSelectedAssetType(opt ? opt.value : '')}
                      isClearable
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label className="form-label required">Quantity</label>
                    <input type="number" className="form-control" min="1" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
                  </div>
                </div>
              </>
            )}
            {/* Department - admin/head only */}
            {canSelectDept && (
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label">Department</label>
                <MultiSelect onChange={(val) => fetchHeadCCMails(val)} options={multidept} closeOnSelect={true} />
              </div>
            </div>
            )}
            {/* Request To */}
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label required">Request To</label>
                <Select
                  placeholder="Select"
                  options={headUsers || []}
                  value={to ? (headUsers || []).find(h => h.value == to) : null}
                  onChange={(opt) => setTo(opt ? opt.value : '')}
                  isClearable
                />
                {toError && <div className="invalid-feedback d-block">{toError}</div>}
              </div>
            </div>
            {/* CC */}
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label">CC</label>
                <MultiSelect onChange={(val) => setCc(val)} options={newHeadsCC} />
              </div>
            </div>
            {/* Subject */}
            <div className="col-md-12">
              <div className="form-group mb-3">
                <label className="form-label required">Subject</label>
                <input type="text" className="form-control" placeholder="Enter subject" value={subject} onChange={(e) => setSubject(e.target.value)} />
                {subjectError && <div className="invalid-feedback d-block">{subjectError}</div>}
              </div>
            </div>
            {/* Justification (Hardware only) */}
            {selectedCategory === 'hardware_request' && (
              <div className="col-md-12">
                <div className="form-group mb-3">
                  <label className="form-label required">Justification</label>
                  <textarea className="form-control" rows="2" placeholder="Why do you need this?" value={justification} onChange={(e) => setJustification(e.target.value)} />
                </div>
              </div>
            )}
            {/* Description */}
            <div className="col-md-12">
              <div className="form-group mb-3">
                <label className="form-label required">Description</label>
                <JoditEditor ref={editor} config={config} value={reason} tabIndex={1} onBlur={(c) => setReason(c)} onChange={() => {}} />
                {reasonError && <div className="invalid-feedback d-block">{reasonError}</div>}
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-footer">
                <button type="button" className="mr-3 btn btn-primary" onClick={handleSubmit} disabled={disabled}>
                  {disabled ? "Submitting..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ApplyTickets;
